<div class="location-panel">
  <!-- Coordinate Inputs Row -->
  <div class="row g-3 mb-3">
    <!-- Latitude Input -->
    <div class="col-md-6">
      <label class="form-label">Latitude</label>
      <input
        type="number"
        class="form-control"
        [ngModel]="currentLat"
        (ngModelChange)="onLatitudeChange($event)"
        placeholder="ex: 39.82"
        step="0.000001"
        min="-90"
        max="90"
      />
      <div class="form-text text-muted" *ngIf="latitudeDMS">
        Current Latitude: {{ latitudeDMS }}
      </div>
      <div class="form-text" *ngIf="!latitudeDMS">
        Decimal Degrees format (ex: 39.82)
      </div>
    </div>

    <!-- Longitude Input -->
    <div class="col-md-6">
      <label class="form-label">Longitude</label>
      <input
        type="number"
        class="form-control"
        [ngModel]="currentLon"
        (ngModelChange)="onLongitudeChange($event)"
        placeholder="ex: -98.58"
        step="0.000001"
        min="-180"
        max="180"
      />
      <div class="form-text text-muted" *ngIf="longitudeDMS">
        Current Longitude: {{ longitudeDMS }}
      </div>
      <div class="form-text" *ngIf="!longitudeDMS">
        Decimal Degrees format (ex: -98.58)
      </div>
    </div>
  </div>

  <!-- Get Current Location Button -->
  <div class="mb-3">
    <button
      type="button"
      class="btn btn-outline-primary"
      (click)="onGetCurrentLocation()"
      [disabled]="isLoadingLocation"
    >
      <ng-container *ngIf="!isLoadingLocation">
        <i class="bi bi-geo-alt me-2"></i>Get Current Location
      </ng-container>
      <ng-container *ngIf="isLoadingLocation">
        <span class="spinner-border spinner-border-sm me-2" role="status"></span>
        Getting location...
      </ng-container>
    </button>
    <div class="form-text">
      <small class="text-muted">
        NOTE: You may need to allow location services in your browser settings
      </small>
    </div>
    <div class="text-danger small mt-1" *ngIf="locationError">
      {{ locationError }}
    </div>
  </div>

  <!-- Address Search -->
  <div class="mb-3">
    <label class="form-label">Search for a location</label>
    <input
      type="text"
      class="form-control"
      #addressSearchInput
      [value]="currentAddress || ''"
      placeholder="Search for a location"
    />
  </div>

  <!-- Instruction Text -->
  <div class="mb-3">
    <p class="text-muted small mb-0">
      Click on the map to pick your location, or drag the red marker (if visible on the map) to update the location.
    </p>
  </div>

  <!-- Map Picker -->
  <app-map-picker
    [initialLat]="currentLat"
    [initialLon]="currentLon"
    (coordinateSelected)="onMapCoordinateSelected($event)"
  ></app-map-picker>
</div>
